import React from 'react';
import My from "./fig.jpg";


function Avator() {
 return (
  <div className="avator_container">
      <div>
         <img src={My} alt="kevin shikuku" className="avator" />
       </div>
      <div className="avatoor">
         <p> FOURTH YEAR STUDENT</p>
         <p> Bachelor Of Business Administration With IT (Sales and Marketing.) </p> <br/>
         <p> <a href="https://tmuc.ac.ke/" >TOM MBOYA UNIVERSITY COLLEGE. </a> A constituent college of Maseno University</p>
      </div>
  </div>
 )
}

export default Avator
